/**
 * Reusable contest status pill. Consistent color coding across every
 * surface (list, detail, dashboard, my submissions).
 */
import { deriveContestDisplayStatus } from "@/lib/contestStatus";

export const ContestStatusBadge = ({ contest, className = "", size = "sm" }) => {
  const s = deriveContestDisplayStatus(contest);
  const sizeCls = size === "lg" ? "text-xs px-3 py-1" : "text-[10px] px-2 py-0.5";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-black uppercase tracking-wider border ${s.tone} ${sizeCls} ${className}`}
      data-testid={`contest-status-badge-${s.key}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
};

export default ContestStatusBadge;
